import LoadingIndicator from "components/shared/LoadingIndicator";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useGetCmsPageQuery } from "store/services/cms";

const Videos = () => {

    const { data, isLoading, isFetching } = useGetCmsPageQuery("videos");

    return (
        <>
            <section className="client position-relative py-4">
                <Container fluid>
                    <Row>
                        {
                            isLoading || isFetching ? <LoadingIndicator /> : (
                                <Col lg="12" className="my-3">

                                    <h3 className="fw-bold">{data?.title || ""}</h3>

                                    {data?.cover_img && <img style={{ width: "100%", height: "400px" ,objectFit:"fill"}} src={data?.cover_img} />}
                                    <div
                                        className="w-100 my-3"
                                        dangerouslySetInnerHTML={{ __html: data?.description }}
                                    >
                                    </div>

                                    {
                                        data?.videos?.length && (
                                            <Row>
                                                {
                                                    data?.videos?.map((item, index) => {
                                                        return (
                                                            <Col lg="6" key={index} className="my-2">
                                                                <video controls className="w-100">
                                                                    <source src={item?.attachment_key} type="video/mp4" />
                                                                </video>
                                                            </Col>
                                                        )
                                                    })
                                                }
                                            </Row>
                                        )
                                    }
                                </Col>
                            )
                        }
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Videos;
